import { Engineering } from '@mui/icons-material';
import { Fab } from '@mui/material';
import { RouteLink, useAmplifyServiceContext } from '@scorenco/core';

export const AdminDjango = ({ service, table, id }) => {
  const { user } = useAmplifyServiceContext();

  if (!user?.info?.is_superuser) {
    return null;
  }

  return (
    <RouteLink
      href={`https://${process.env.NEXT_PUBLIC_REST_ENDPOINT}/${service}/admin/${service}/${table}/?id=${id}`}
    >
      <Fab
        variant="extended"
        size="small"
        color="warning"
        sx={{ position: 'fixed', bottom: 32, right: 110 }}
      >
        <Engineering sx={{ mr: 1 }} />
        {table} - Django
      </Fab>
    </RouteLink>
  );
};
